import { useEffect } from 'react';

import { type ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { fg } from '@atlaskit/platform-feature-flags';

import { type AIDefinitionsPlugin } from '../../aiDefinitionsPluginType';

export function useManageSelectionToolbarVisibility({
	api,
	show,
}: {
	api?: ExtractInjectionAPI<AIDefinitionsPlugin>;
	show: boolean;
}): void {
	useEffect(() => {
		if (!fg('platform_editor_fix_suppress_toolbar')) {
			if (show) {
				api?.selectionToolbar.actions?.suppressToolbar?.();
			} else {
				api?.selectionToolbar.actions?.unsuppressToolbar?.();
			}

			return () => {
				api?.selectionToolbar.actions?.unsuppressToolbar?.();
			};
		}
	}, [api?.selectionToolbar.actions, show]);

	useEffect(() => {
		if (fg('platform_editor_fix_suppress_toolbar')) {
			if (show) {
				api?.selectionToolbar.actions?.suppressToolbar?.();
			} else {
				api?.selectionToolbar.actions?.unsuppressToolbar?.();
			}

			return () => {
				api?.selectionToolbar.actions?.unsuppressToolbar?.();
			};
		}
	}, [api, show]);
}
